// @ts-nocheck
import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
import translate from "@insite/client-framework/Translate";
import Checkbox from "@insite/mobius/Checkbox";
import TextField from "@insite/mobius/TextField";

import Typography from "@insite/mobius/Typography";
import {
    ButtonRow,
    EmailMeContainer,
    generateInputStyles,
    SignaturePadCard,
    Title,
} from "@store/Library/Components/Signature/SharedSignatureModalStyles";

import SignatureCanvas from "react-signature-canvas";

import { SigningModalOverrides } from "@store/Library/Components/Signature/SigningModal";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import styled from "styled-components";
import Button from "@store/MobiusOverrides/Button/Button";

interface EditableModalDisplayProps {
    isEmpty: boolean;
    setIsEmpty: React.Dispatch<React.SetStateAction<boolean>>;
    signingModalOverrides?: SigningModalOverrides;
    acknowledgeText?: string;
    editableName?: boolean;
    isEmailRequired: boolean;
    setIsEmailRequired: React.Dispatch<React.SetStateAction<boolean>>;
    signatureRef: React.RefObject<SignatureCanvas>;
    canvasWidth?: number;
    canvasHeight?: number;
    customerName: string;
    setCustomerName: React.Dispatch<React.SetStateAction<string>>;
    emailAddress: string;
    setEmailAddress: React.Dispatch<React.SetStateAction<string>>;
    hasSubmitted: boolean;
    setClearModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    handleSave: () => void;
    hideEmail?: boolean;
}

const canvasStyles: React.CSSProperties = {
    width: "100%",
    height: "100%",
};
const Declaration = styled(Typography)`
    align-self: flex-start;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: ${pxToRem(16)};
    white-space: wrap;
    row-gap: 1rem;
    padding-inline: ${pxToRem(8)};
`;

const EditableModalDisplay: React.FC<EditableModalDisplayProps> = ({
    setCustomerName,
    handleSave,
    setClearModalOpen,
    setEmailAddress,
    setIsEmailRequired,
    signatureRef,
    signingModalOverrides,
    canvasHeight,
    canvasWidth,
    customerName,
    emailAddress,
    hasSubmitted,
    isEmailRequired,
    acknowledgeText,
    hideEmail,
    editableName = true,
    isEmpty,
    setIsEmpty,
}) => {
    const isValidForm = () => {
        if (isEmpty) {
            return false;
        }
        if (!isEmailRequired || !hasSubmitted) {
            return !!customerName;
        }
        return customerName && validateEmail(emailAddress);
    };

    return (
        <>
            <Declaration variant="h4" {...signingModalOverrides?.declarationProps}>
                {editableName && (
                    <>
                        {translate("I")},
                        <TextField
                            {...generateInputStyles(false)}
                            onChange={event => setCustomerName(event.target.value)}
                            value={customerName}
                            placeholder={translate("Name here")}
                            {...signingModalOverrides?.signingInputProps}
                        />
                        <Typography>
                            {acknowledgeText ??
                                translate("hereby acknowledge that I have received the product(s) for this order.")}
                        </Typography>
                    </>
                )}
                {!editableName && (
                    <Title style={{ textIndent: 0 }} variant="h5">
                        {translate(`I, `)} <Typography underline>{customerName}</Typography>
                        {` ${
                            acknowledgeText ??
                            translate(`hereby acknowledge that I have received the product(s) for this order. `)
                        }`}
                    </Title>
                )}
            </Declaration>

            <SignaturePadCard {...signingModalOverrides?.signaturePadCardProps}>
                <SignatureCanvas
                    onEnd={() => setIsEmpty(signatureRef.current?.isEmpty() ?? true)}
                    penColor="#0D2C6B"
                    canvasProps={{ style: canvasStyles, width: canvasWidth, height: canvasHeight }}
                    ref={signatureRef}
                />
            </SignaturePadCard>

            {!hideEmail && (
                <EmailMeContainer {...signingModalOverrides?.emailMeContainerProps}>
                    <Checkbox
                        // @ts-ignore
                        iconProps={{ size: 18, style: { minWidth: 18 } }}
                        checked={isEmailRequired}
                        onChange={() => setIsEmailRequired(isEmailRequired => !isEmailRequired)}
                    >
                        {translate("I would like a copy emailed to me")}
                    </Checkbox>

                    {isEmailRequired && (
                        <TextField
                            value={emailAddress}
                            onChange={event => setEmailAddress(event.target.value)}
                            placeholder={translate("Email address")}
                            error={
                                !validateEmail(emailAddress) && hasSubmitted
                                    ? translate("Invalid email address")
                                    : undefined
                            }
                            {...generateInputStyles(true)}
                            {...signingModalOverrides?.emailInputProps}
                            mergeCss
                        />
                    )}
                </EmailMeContainer>
            )}

            <ButtonRow {...signingModalOverrides?.buttonRowProps}>
                <>
                    <Button
                        onClick={() => setClearModalOpen(true)}
                        variant="tertiary"
                        {...signingModalOverrides?.clearButtonProps}
                    >
                        {translate("Clear")}
                    </Button>
                    <Button
                        disabled={!isValidForm()}
                        onClick={handleSave}
                        {...signingModalOverrides?.saveButtonProps}
                        css={signingModalOverrides?.saveButtonProps?.css}
                    >
                        {translate("Save")}
                    </Button>
                </>
            </ButtonRow>
        </>
    );
};

export default EditableModalDisplay;
